module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg3.c28e094d.png";